/** Documento do REST do Firestore (`{ fields: { x: { stringValue } } }`) → objeto comum. */
export function valorDoRest(v) {
  if (!v || typeof v !== 'object') return null;
  if ('stringValue' in v) return v.stringValue;
  if ('booleanValue' in v) return v.booleanValue;
  if ('integerValue' in v) return Number(v.integerValue);
  if ('doubleValue' in v) return v.doubleValue;
  if ('nullValue' in v) return null;
  if ('timestampValue' in v) return v.timestampValue;
  if ('arrayValue' in v) return (v.arrayValue.values || []).map(valorDoRest);
  if ('mapValue' in v) return camposDoRest(v.mapValue.fields);
  return null;
}

export function camposDoRest(f) {
  const o = {};
  for (const [k, v] of Object.entries(f || {})) o[k] = valorDoRest(v);
  return o;
}
